export type TCountryCode = "US" | "MX" | "CA";

export const SUPPORTED_COUNTRIES: {
  code: TCountryCode;
  name: string;
  marketplaceId: string;
  icon: string;
}[] = [
  {
    code: "US",
    name: "US",
    marketplaceId: "ATVPDKIKX0DER",
    icon: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg", // US flag URL
  },
  {
    code: "MX",
    name: "Mexico",
    marketplaceId: "A1AM78C64UM0Y8",
    icon: "https://upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Mexico.svg", // Mexico flag URL
  },
  {
    code: "CA",
    name: "Canada",
    marketplaceId: "A2EUQ1WTGCTBG2",
    icon: "https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Canada.svg", // Canada flag URL
  },
  // {
  //   code: "UK",
  //   name: "UK",
  //   marketplaceId: "A1F83G8C2ARO7P",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_Kingdom.svg", // UK flag URL
  // },
  // {
  //   code: "IT",
  //   name: "Italy",
  //   marketplaceId: "APJ6JRA9NG5V4",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/0/03/Flag_of_Italy.svg", // Italy flag URL
  // },
  // {
  //   code: "NL",
  //   name: "Netherlands",
  //   marketplaceId: "A1805IZSGTT6HS",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg", // Netherlands flag URL
  // },
  // {
  //   code: "DE",
  //   name: "Germany",
  //   marketplaceId: "A1PA6795UKMFR9",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg", // Germany flag URL
  // },
  // {
  //   code: "FR",
  //   name: "France",
  //   marketplaceId: "A13V1IB3VIYZZH",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_France.svg", // France flag URL
  // },
  // {
  //   code: "SE",
  //   name: "Sweden",
  //   marketplaceId: "A2NODRKZP88ZB9",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Sweden.svg", // Sweden flag URL
  // },
  // {
  //   code: "SP",
  //   name: "Spain",
  //   marketplaceId: "A1RKKUPIHCS9HS",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg", // Spain flag URL
  // },
  // {
  //   code: "PL",
  //   name: "Poland",
  //   marketplaceId: "A1C3SOZRARQ6R3",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/1/12/Flag_of_Poland.svg", // Poland flag URL
  // },
];
